
// Module
import axios from 'axios';
import dompurify from "dompurify";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { atelierForestLight } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

// CSS
import '_Asset/css/User/Page/develop.css';

// API
import { KmListApi, KmSgApi } from "_Route/Api";

// Component
import KmTree from 'User/Component/KmTree';


const APIManualDt = () => {

  const navigate = useNavigate()
  const params = useParams();
  const location = useLocation();
  const sanitizer = dompurify.sanitize;

  const [kmData, setKmData] = useState('')
  const [kmAllData, setKmAllData] = useState([])
  const [parentData, setParentData] = useState('')
  const [isExpand, setIsExpand] = useState(false)


  const FormatConv = (date) => {
    const newDate = new Date(date);

    const month = newDate.toLocaleString("en-US", { month: "short" })
    const dt = newDate.getDate();
    const year = newDate.getFullYear();

    return (month + ' ' + dt + ', ' + year)
  }
  

  // 트리 메뉴 생성 재귀 함수
  const treeMenu = (kmMenuData, data, state) => {    
    data.map(key => {
      const nextDepth = kmMenuData?.filter(list => key.km_id === list.km_parent && list.km_depth !== 0)
      const prevDepth = kmMenuData?.filter(list => list.km_id === key.km_parent)
      const depthChk = key.km_id === key.km_parent && state === false
      
      if (depthChk) { return 0 }
      if(nextDepth.length !== 0 && key.children === undefined) {
        key.children = nextDepth
        treeMenu(kmMenuData, nextDepth, false)
      }
      else if (nextDepth.length === 0) {
        treeMenu(kmMenuData, prevDepth, false)
      }
    })
  }

  const [treeMenuData, setTreeMenuData] = useState([]);
  useEffect(() => {
    // KM 전체 메뉴 조회
    axios({
      method: 'GET',
      url: KmListApi,
    })
    .then(res => {
      // console.log(res, 'KM Menu List GET Success!')
      const result = res.data.result;

      const curList = result.find(key => key.km_id === params.id);
      setParentData(result.find(key => key.km_id === curList.km_parent && curList.km_id !== curList.km_parent))
      setKmAllData(result)

      // API 참조 문서 트리 메뉴
      if(params.id === '10911946') {
        let treeDataTemp = result?.filter(key => key.km_parent === params.id && key.km_depth !== 0);
        treeMenu(result, treeDataTemp, true)
        setTreeMenuData(treeDataTemp)
      }

    })
    .catch(err => {
      console.error(err, "KM Menu List GET Error...")
    })

    // KM 상세 정보 조회
    axios.get(KmSgApi, {
      params: {
        km_id: params.id
      }
    })
    .then(res => {
      // console.log(res, 'KM Current Menu GET Success!')
      const result = res.data.result[0]
      if (result) {
        setKmData(result);
      } else {
        navigate('/404')
      }
    })
    .catch(err => {
      console.error(err, "KM Current Menu GET Error...")
    })
  }, [location])

  
  // CKEditor5 코드 블럭 Syntax Highlight
  const replaceData = kmData.km_content?.replaceAll('&amp;', '&').replaceAll('&quot;', '"')
  const preRegExp = /(?=<pre>)|\.<\/pre>/g; // 코드 블럭 유효성 TEST

  let splitCont = replaceData?.split('<pre>')
  let arrTemp = [];
  splitCont?.map(key => {
    key.split('</pre>').map(key2 => {
      if(key2.startsWith('<code')) {
        arrTemp.push(`<pre>${key2}</pre>`)
      } else {
        arrTemp.push(key2)
      }
    })
  })

  const splitRegExp = (str, startTag, endTag) => {
    const splitTemp = str.split(startTag)[1]

    return splitTemp.split(endTag)[0]
  }

  
  return (
    <>
      {/* Visual */}
      <div className="visual develop center">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Seyfert KM</h2>
          </div>
        </div>
      </div>

      <div className="mainContents">
        {
          kmData &&
          <>
            <div className="section">
              <div className="kmArea areaBox">
                <div className="titGroup">
                  <h2 className="kmTitle">
                    {kmData.km_title}
                    <button type="button" className="btn sm sfrtBlue round_10" onClick={() => navigate(`/develop/apis-manual${parentData === undefined ? '' : `/${parentData.km_grp}/${parentData.km_id}`}`)}><i className="icofont-arrow-left" />{parentData === undefined ? '메인 페이지로 이동' : '상위 메뉴로 이동'}</button>
                  </h2>

                  <p>{`last modified on ${FormatConv(kmData.km_last_modify_date)}`}</p>
                </div>

                <div className="kmContent">
                  {arrTemp.map((key, i) => 
                    // key.startsWith('<pre>') ?
                    preRegExp.test(key) ?
                    <SyntaxHighlighter
                      key={i}
                      showLineNumbers={true}
                      lineProps={{style: {wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}}
                      wrapLines={true}
                      language={splitRegExp(key, '"language-', '">') === 'html' ? 'htmlbars' : splitRegExp(key, '"language-', '">')}
                      style={atelierForestLight}
                    >
                      {splitRegExp(key, '">', '</code>')?.replaceAll('&lt;', '<')?.replaceAll('&gt;', '>')?.replaceAll('&nbsp;', ' ')}
                    </SyntaxHighlighter>
                    :
                    <div key={i} dangerouslySetInnerHTML={{ __html: sanitizer(key)}}></div>
                  )}
                </div>

                  {
                    params.id === '10911946' && // API 참조문서 전체 메뉴 보기
                    <div className="apiRef">
                      <div className="refBtn">
                        <button type="button" onClick={() => setIsExpand(true)}>Expand all</button>
                        <button type="button" onClick={() => setIsExpand(false)}>Collapse all</button>
                      </div>

                      <ul>
                        {treeMenuData.map((data, i) =>
                          <KmTree
                            key={i}
                            child={data}
                            depth={0}
                            isExpand={isExpand}
                          />
                        )}
                      </ul>
                    </div>
                  }
              </div>
            </div>
          </>
        }
      </div>
      </>
  )
}

export default APIManualDt;